import React, { useEffect, useState, useRef } from "react";
import { inlineSettings } from "./tinyconfig";
import { Editor } from "@tinymce/tinymce-react";
import LinkManager from "../LinkManager/LinkManager";
import { archiveConstants } from "../FileStorage/contstants/archive.contstants";
import FileStorageWrapper from "../FileStorage/FileStorageWrapper";
import { TinyMCE } from "tinymce";
const  getGlobal = function () { return (typeof window !== 'undefined' ? window : global); };
const setTinymce = function () {
    var global = getGlobal();
    if(global && !global.tinymce)
      global.tinymce = TinyMCE;
};

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

export const InlineEditor = (props) => {
  const [editor, setEditor] = useState({});
  const [cycleEditor, setCycleEditor] = useState(false);
  const [archiveOpen, setArchiveOpen] = useState(false);
  const [linkHelperOpen, setLinkHelperOpen] = useState(false);
  const [text, setText] = useState("");
  const [focus, setFocus] = useState(false);
  const prevText = usePrevious(props.value);
  setTinymce();
  useEffect(() => {
    if (cycleEditor) setCycleEditor(false);
  }, [cycleEditor]);

  useEffect(() => {
    if (props.value != prevText) {
      setText(props.value);
    }
  }, [props.value]);

  const onInit = (editor) => setEditor(editor);
  const handleKeyUp = (e) => {
    if (!focus) return;

    const { value, globalFormat, onChange, path, slimFormat } = props;
    var content = editor.getContent();
    if (content !== value) {
      if (globalFormat === true) {
        onChange(null, content, path);
      } else if (slimFormat === true) {
        onChange(content, path);
      } else {
        onChange(content);
      }
    }
    setText(content);
  };
  const formatImage = () => {
    const content = editor.getContent();
    props.onChange(content);
  };
  const onArchiveUseSelect = (url) => {
    var image = new Image();
    image.crossOrigin = "anonymous"; /* THIS WILL MAKE THE IMAGE CROSS-ORIGIN */
    image.src = url;
    let content = editor.insertContent(`<img src="${image.src}"  alt="_blank" height="auto" width="100%" /> `);
    content = editor.getContent();
    props.onChange(content);
  };
  const onLinkSelect = (url) => {
    let content = editor.insertContent(`<a href=${url}  target="blank"  /> `);
    content = editor.getContent();
  };
  const { value, onChange } = props;
  return (
    <>
      <Editor
        /*       initialValue={value} */
        value={text || '<p></p>'}
        onFocusIn={() => {
          setFocus(true);
        }}
        onFocusOut={() => {
          setFocus(false);
        }}
        onInit={(event, editor) => onInit(editor)}
        init={{
          ...inlineSettings,
          /*    content_style: style, */
          width: "100%",
          height: "100%",
          setup: (editor) => {
            editor.ui.registry.addButton("archive", {
              icon: "image",
              image: "image",
              onAction: () => setArchiveOpen(!archiveOpen),
            });
            editor.ui.registry.addButton("linkHelper", {
              icon: "link",
              image: "link",
              onAction: () => setLinkHelperOpen(!linkHelperOpen),
            });
          },
        }}
        onEditorChange={(e) => handleKeyUp(e)}
        /*           onEditorChange={(e) => handleKeyUp(e)} */
      />

      {archiveOpen ? (
        <FileStorageWrapper
          fontEnabled={false}
          onUseSelected={onArchiveUseSelect}
          onFontUpload={() => null}
          toggle={() => setArchiveOpen(!archiveOpen)}
          isOpen={true}
          initialDisplay={archiveConstants.IMAGE}
          showLaunchBtn={false}
        />
      ) : null}
      {linkHelperOpen ? <LinkManager setLink={onLinkSelect} /> : null}
    </>
  );
};
